var $ = global.jQuery = global.$;

var dot = require('dot');
var parser = require('../lib/parser');

var Form = require('./Form');
var Loading = require('./Loading');

/**
 * Track CSS properties
 * @class
 * @extends _Base
 */
var LoadMore = Form.extend(
  /** @lends LoadMore.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    this.loadingWidget = new Loading(this.$el);
    this.firstRun = true;
    this._super();
  },
  onWidgetsReady: function() {
    var self = this;

    this._super();

    this.action = this.$el.attr('action');
    this.currentPage = 0;

    this.$loadMoreButton = this.$el.find('[data-load-more-button]');
    this.$loadMoreItems = this.$el.find('[data-load-more-items]');

    this.templateRaw = this.$el.find('[data-load-more-template]').text().trim();
    this.template = dot.template(this.templateRaw);

    this.getMoreItems();

    this.$el.on('submit', function(event) {
      event.preventDefault();
      self.getMoreItems();
    });
  },
  getMoreItems: function() {
    var self = this,
        formData = this.getFieldValues();
    formData.Page = this.currentPage + 1;

    return $.ajax({
      type: 'GET',
      contentType: 'application/json',
      url: this.action,
      data: formData
    })
    .done(function(response) {
      var item;
      if (response.Value) {
        self.currentPage = response.Value.Metadata.CurrentPage;
        if (response.Value.Metadata && response.Value.Metadata.CurrentPage === response.Value.Metadata.TotalPages) {
          self.$loadMoreButton.hide();
        } else {
          self.$loadMoreButton.show();
        }
        if (response.Value.Items) {
          self.loadItems(response.Value.Items);
        }
      } else if (response.Error && response.Error !== '') {
        self.$el.trigger('Loading:Failed', [response.Error]);
      }
    })
    .fail(function() {
      self.$el.trigger('Loading:Failed');
    });
  },
  loadItems: function(items) {
    var self = this;
    $.each(items, function(index) {
      var item = this;
      setTimeout(function() {
        self.$loadMoreItems.append(self.template(item));
      }, index * 100);
    });

    setTimeout(function(){
      parser.parse(self.$loadMoreItems);
      if (self.firstRun) self.$el.trigger('Loading:Success');
      self.firstRun = false;
    }, items.length * 100);

  }
});

module.exports = LoadMore;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/LoadMore.js
// module id = 299
// module chunks = 0